import { useEffect } from 'react';

import { isToolExcludedFromSuggestedPersonas } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { CustomerPersonaStore } from 'src/store';

import { MainStore } from '../../../store';
import { LocalStore, useLocalActions } from '../store';

const useLocalState = createStateSelectorHook(LocalStore, ['selectedCustomerPersona']);
const useCustomerPersonaState = createStateSelectorHook(CustomerPersonaStore, [
  'suggestedCustomerPersonas',
]);
const useMainStore = createStateSelectorHook(MainStore, ['generationTool']);

export const useFallbackToDefaultCustomerPersona = () => {
  const localActions = useLocalActions();
  const { suggestedCustomerPersonas } = useCustomerPersonaState();
  const { selectedCustomerPersona } = useLocalState();
  const { generationTool } = useMainStore();

  useEffect(() => {
    if (!selectedCustomerPersona?.isSuggested) {
      return;
    }

    const toolExcludesSuggestedPersonas = isToolExcludedFromSuggestedPersonas(generationTool);
    const isCustomerPersonaValid = suggestedCustomerPersonas.some(
      ({ id }) => id === selectedCustomerPersona.id
    );

    if (toolExcludesSuggestedPersonas || !isCustomerPersonaValid) {
      localActions.selectProjectPersona(null);
    }
  }, [localActions, selectedCustomerPersona, suggestedCustomerPersonas, generationTool]);
};
